import { render } from "./LocalUpdate.vue?vue&type=template&id=0c191fd3"
import script from "./LocalUpdate.vue?vue&type=script&lang=js"
export * from "./LocalUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__